module.exports = __webpack_public_path__ + "static/media/front.26134076.jpg";